<template>
    <v-container grid-list-md>
        <v-row>
            <v-col>
                <div id="eventdesc">
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import $ from 'jquery';
    var md = require('markdown-it')({html: true});

    export default {
        props: ['id', 'apihost', 'city'],
        watch: {
            '$i18n.locale': function() {
                this.load_details();
            },
        },
        methods: {
            load_details() {
                let self = this;
                $.get(`${self.apihost}/uclim/content/${self.city}/${self.id}_${this.$i18n.locale}.md`, function(markdown) {
                    $('#eventdesc').html(md.render(markdown));
                });
            }
        },
        mounted() {
            this.load_details();
        }
    }
</script>